import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
//import cookie from 'react-cookie';
import './user.css';

export default class Register extends Component {
	constructor(props) {
		super(props);
		this.register = this.register.bind(this);
		this.inputChange = this.inputChange.bind(this);
		this.state = {};
	}
	render() {
		const redirect = this.state.redirect;
		if(redirect === true) {
			console.log('redirect');
			return <Redirect to="/login/registered" />
		}
		console.log('Register');
		return (
			<form method="post" action="https://atrond.com/services/register" onSubmit={ this.register }>
				<label htmlFor="email">E-mail aadress</label>
				<input id="email" name="email" type="email" onChange={ this.inputChange } />
				<label htmlFor="password">Password</label>
				<input id="password" name="password" type="password" onChange={ this.inputChange } />
				<label htmlFor="password2">Repeat password</label>
				<input id="password2" type="password" name="password2" onChange={ this.inputChange } />
				<p><label><input type="checkbox" name="terms" onChange={ this.inputChange } /> I agree with the <a href="terms">Terms and conditions</a></label></p>
				<button onClick={ this.login }>Register</button>
			</form>
		);
	}
	register(e) {
		e.preventDefault();
		console.log('do register', this.state);
		fetch('https://atround.com/services/register.php',
		{
			method: "POST",
			headers: {
    		"Accept": "application/json",
  		},
			body: JSON.stringify(this.state)
		})
		.then(response => response.json())
		.then(
			(result) => {
			console.log(result);
			if(result.error === true) {
				console.log('eroor');
			}
			else if(result.data !== false) {
				console.log('kõik hea');
				this.setState({ redirect: true });
			}
		},
			// Note: it's important to handle errors here
			// instead of a catch() block so that we don't swallow
			// exceptions from actual bugs in components.
			(error) => {
				console.log(error);
				this.setState({
          isLoaded: true,
          error
        });
			}
		)
	}

	inputChange(e) {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
		console.log(value);
  }
}



// WEBPACK FOOTER //
// ./src/components/register.jsx